<div class="container-fluid p-0">
  @if(auth.authenticated){
  <app-sidebar></app-sidebar>
  }
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
@if(showSpinner){
  <div class="fullscreen-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
}